<template>
  <div class="header">
    <header>
      <div v-if="!showTitle" class="left">
        <div class="refresh" @click="refresh" v-show="showRefreshIcon">
          <i class="el-icon-refresh"></i>
        </div>
        <div @click="pushMessage('这是一条通知内容')" class="logo"></div>
        <div class="title" v-text="title"></div>
        <div class="item">
        </div>
      </div>
      <div v-else class="left taskTitle">
        <span>{{ taskTitle }}</span>
      </div>
      <div v-if="noviceProtectionEndTime" class="center">
        新手保护结束时间：{{noviceProtectionEndTime}}
      </div>

      <div class="right">
        <template v-if="!isCalling && showCallBtn">
          <!--<div class="item btn" @click="calling">自动拨号</div>-->
        </template>


        <template v-else-if="isCalling && showCallBtn">
          <div class="item callingtime" v-text="`通话时长 ${secondText}`"></div>
          <div class="item btn" @click="hangUp">挂断</div>
          <template v-if="isCallHold">
            <div class="item btn" @click="callHold">通话保持</div>
          </template>
          <template v-else>
            <div class="item btn" @click="callRetrieve">通话取回</div>
          </template>
        </template>
        <!-- 质控提醒 -->
        <div class="feedback-tooltip" v-show="feedbackTooltipShow">
          <div class="feedback-tooltip-left">
            <div class="tooltip-title">
              <span>{{ feedBackNotConfirm.taskName }}</span><span>{{ feedBackNotConfirm.feedBackTime }}</span>
            </div>
            <div class="tooltip-content">
              <div>患者：{{ feedBackNotConfirm.patientName }}</div>
              <div class="tooltip-content-result">
                <span>类别：{{ feedBackNotConfirm.category }}</span>
                <span>结果：{{ feedBackNotConfirm.result }} </span>
              </div>
              <div class="tooltip-content-question">反馈问题：{{ feedBackNotConfirm.firstSpotCheckRemarks }}
              </div>
            </div>
          </div>
          <div class="feedback-tooltip-right">
            <div class="div1" @click="goTaskDetail">查看详情</div>
            <div class="div2" @click="closeFeedbackTooltip">稍后</div>
          </div>
        </div>
        <!-- 稍后拨打提醒 -->
        <div class="feedback-tooltip call-reminder" v-show="callReminderShow" v-for="(item,index) in callReminderInfo"
             :key="index">
          <div class="feedback-tooltip-left">
            <div class="tooltip-title">
              <span>{{ item.taskName }}</span><span>{{ item.feedBackTime }}</span>
            </div>
            <div class="tooltip-content">
              <div>稍后随访预约的时间到了</div>
              <div>随访患者： {{ item.patientName }}</div>
            </div>
          </div>
          <div class="feedback-tooltip-right">
            <div class="div1" @click="goCallLaterTaskDetail(item)">查看</div>
            <div class="div2" @click="closeCallReminderTooltip(item,index)">稍后</div>
          </div>
        </div>

        <!--                <div @click="getSpeed()">-->
        <!--                    <img style="width: 30px; height: 30px;" v-if="speed > 800" src="./img/fast.png" alt="">-->
        <!--                    <img style="width: 30px; height: 30px;" v-else src="./img/slow.png" alt="">-->
        <!--                </div>-->

        <div class="item feedback" style="margin: 0 15px;cursor: pointer;">
          <i class="el-icon-chat-line-square" style="font-size: 34px;"  @click="openFeedbackDrawer"></i>
        </div>
        <!-- <div class="item feedback">
          <el-button
              type="warning"
              @click="openDialog"
              class="feedback-btn"
              round
          >
            <div v-if="unreadCount" class="feedback-btn-bot">{{ unreadCount }}</div>
            <i v-else class="el-icon el-icon-check"></i>
            <span>质控反馈</span>
          </el-button>
        </div> -->
        <!-- <div class="item gonghao">
            <span v-text="`您好，${jobName}（${jobnum}）`"></span>
        </div> -->
        <!--<template v-if="status==='work'">-->
        <!--<div class="item btn" @click="getRest">休息一下</div>-->
        <!--</template>-->
        <!--<template v-else>-->
        <!--<div class="item btn" @click="backWork">马上回来</div>-->
        <!--</template>-->
        <!-- <div class="item" @click="loginOut">
            <i class="el-icon-close"></i>退出
        </div> -->
        <el-popover
            @show="getDevices"
            placement="bottom"
            width="240"
            trigger="hover">
          <div class="setting">
            <div class="setting-item user-info"><span v-text="`${jobName}（${jobnum}）`"></span></div>
            <div class="setting-item">
              <span>网络</span>
              <div class="network" @click="getSpeed()">
                <img style="width: 18px; height: 18px;" v-if="speed > 800" src="./img/networkGreen.png" alt="">
                <img style="width: 18px; height: 18px;" v-else-if="speed < 800 && speed > 300"
                     src="./img/networkYellow.png" alt="">
                <img style="width: 18px; height: 18px;" v-else src="./img/networkRed.png" alt="">
              </div>
            </div>
            <div class="setting-item hover " @click="getDebugDialog('earphone')"><span
                class="ove">{{ defaultDevices.earphone }}</span>
            </div>
            <div class="setting-item hover " @click="getDebugDialog('micro')"><span
                class="ove">{{ defaultDevices.mic ? defaultDevices.mic : '未插入麦克风' }}</span>
            </div>
            <div class="setting-item hover" @click="studyDrawerClick"><span>学习材料</span></div>
            <div class=" logout"><span @click="loginOut"><img
                src="./img/logout.png"/>退出登录</span></div>
          </div>
          <!--                    <el-button slot="reference">hover 激活</el-button>-->
          <div slot="reference" class="user-icon">
            <img src="./img/userIcon.png" alt="">
          </div>
        </el-popover>
      </div>

      <!-- 学习材料 -->
      <div class="study-drawer" v-if="studyDrawer">
        <div class="drawer-title">
          <span>学习材料</span>
          <i class="el-icon-close" @click="handleDrawerClose"></i>
        </div>
        <div class="drawer-container">
          <div class="study-searcher">
            <el-select v-model="taskId" @change="selectTaskHandler" placeholder="请选择任务">
              <el-option
                  v-for="item in taskOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
              </el-option>
            </el-select>
            <el-select clearable @change="selectFloderHandler"  v-model="selectFloder">
              <el-option :label="item.folderName" :value="item.fileFolderId" v-for="(item,index) in floderList" :key="item.fileFolderId"></el-option>
            </el-select>
          </div>
          <div class="study-list">
            <div
                @click="previewHandler(item)"
                v-for="(item, index) in fileList"
                :key="index"
                class="article-item"
            >
              <span style="color:#000;font-size:15px;">{{ item.fileName }} <span v-if="item.showDot" style="color: red;font-size: 16px;font-weight: 700;margin-left: 15px;">新</span></span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <el-dialog v-if="message" :title="message.title" :visible.sync="dialogVisible" width="30%">
      <span style="line-height: 25px">{{ message.content }}</span>
    </el-dialog>
    <!-- 质控反馈 -->
    <el-dialog title="" :visible.sync="dialogTableVisible" class="feedback-dialog">
      <el-tabs v-model="dialogActiveName" @tab-click="handleClick">
        <el-tab-pane label="随访反馈" name="feedback">
          <el-collapse accordion v-model="activeNames" @change="handleChange">
            <el-collapse-item v-for="(item,index) in feedBackList" :key="index" :name="index"
                              :class="feedBackNotConfirm.id == item.id?'height-light':''">
              <template slot="title">
                <span :class="{'danger': item.isUrgent && !item.isConfirm}">{{ item.taskName }}</span>
                <el-tag type="success" v-if="item.isConfirm">已读</el-tag>
                <el-tag type="danger" v-if="!item.isConfirm">未读</el-tag>
                <el-tag type="danger" style="margin-left: 15px;" v-if="item.isUrgent">紧急</el-tag>
              </template>
              <div v-if="!item.isUrgent" style="text-align: left;">
                <span>随访患者：{{ item.patientName }}</span>
                <span style="margin-left: 15px;">反馈时间：{{ item.feedBackTime }}</span>
              </div>
              <div v-if="!item.isUrgent" style="text-align: left;">
                <span>结果：{{ item.result }}</span>
                <span style="margin-left: 15px;">类别：{{ item.category }}</span>
              </div>
              <div v-if="item.isUrgent" style="text-align: left;">
                <span>反馈问题：{{ item.secondSpotCheckRemarks }}</span>
              </div>
              <div v-else style="text-align: left;">
                <span>反馈问题：{{ item.firstSpotCheckRemarks }}</span>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-count="totalFeedBackPage"
                :current-page="pageIndex"
                @current-change="current_change_feedBackList"
                :hide-on-single-page="true"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="passFailed" name="remind">
          <HrQualityControl ref="HrQualityControl" :key="timer" @closeDialog="closeDialog"/>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>

    <!-- 耳机、麦克风 -->
    <el-dialog :title="debugType == 'earphone' ? '耳机': '麦克风'" :visible.sync="dialogDebugVisible" width="35%">
      <div style="height: 50%;">
        <check-ear-phone @changeType="changeType" :debugType="debugType" :defaultDevices="defaultDevices"
                         v-if="dialogDebugVisible" @close="earphoneCloseHandler"/>
      </div>
    </el-dialog>

    <!--    学习材料-->
    <div class="preview-dialog">
      <previewFileDialog :fullScreen="true" :title="'预览'" v-model="previewDialogVisible">
        <div v-if="previewStuff == 'office'" style="height: 86vh;" slot="pv">
          <iframe
              :src='previewSrc'
              width='100%' height='100%'>
          </iframe>
        </div>
        <div v-else-if="previewStuff == 'pdf'" style="height: 86vh;" slot="pv">
          <iframe
              :src='previewSrc'
              width='100%' height='100%'>
          </iframe>
        </div>
        <div v-else-if="previewStuff == 'video'" style="height: 86vh;" slot="pv">
          <video autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></video>
        </div>
        <div v-else-if="previewStuff == 'audio'" style="height: 86vh;" slot="pv">
          <audio autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></audio>
        </div>
        <div style="text-align: center" v-else-if="previewStuff == 'pic'" slot="pv">
          <img v-viewer="{movable: true}" :src="previewSrc" alt="" style="width: 400px;">
        </div>
      </previewFileDialog>
    </div>
    <!-- 质控反馈-新 -->
    <div >
      <el-drawer
          title="我是标题"
          :visible.sync="feedbackDrawer"
          :with-header="false">
        <FeedbackDrawer ref="FeedbackDrawer" @closeDrawer="closeDrawer" @openNotice="openNotice" :key="timer"></FeedbackDrawer>
      </el-drawer>
    </div>

    <!-- 公告 -->
    <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        title="公告"
        :visible.sync="sysMsgDialogShow"
        class="sysMsgDialog"
        top="10vh"
        width="80%">
      <div class="content">
        <!-- <div class="title">{{noticeData.title}}</div> -->
        <div v-if="noticeData.quotaDetail">
          <div class="title">{{ noticeData.classificationTitle }}</div>
        </div>
        <div class="content_main"><div v-html="noticeData.content"></div></div>
        <div style="font-weight: 700;margin-top: 10px;font-size: 18px;margin-bottom: 15px;" v-if="noticeData.quotaDetail">
          <span style="margin-right: 15px;">{{ noticeData.quotaDetail.timeStr }}</span>
          <span>{{ noticeData.quotaDetail.beginTime }}</span>
          ~
          <span>{{ noticeData.quotaDetail.endTime }}</span>
        </div>
        <div>
          <quotaTable v-if="noticeData.quotaDetail" :classification="noticeData.classification" :quotaDetail="noticeData.quotaDetail"></quotaTable>
        </div>
        <div v-if="noticeData.classification != 1" style="font-size: 18px;font-weight: 700;margin: 15px 0 ;">
          如有疑问，请在企业微信联系医学负责人或培训专家
        </div>
        <div v-if="noticeData.title=='新的周之星诞生了~'" style="text-align:center;">
          <img class="weekstar_img" src="./img/weekstar.png" alt="" />
        </div>
      </div>
      <span v-if="noticeData.classification != 1 && !noticeData.isConfirm" slot="footer" class="dialog-footer">
          <el-button size="mini" @click="sysMsgDialogShow = false" type="danger">暂不确认</el-button>
          <el-button  size="mini" type="primary" @click="confirmStatusHandler">确认收到</el-button>
        </span>
      <span v-else slot="footer" class="dialog-footer">
          <el-button v-if="noticeData.classification != 1" size="mini" @click="sysMsgDialogShow = false" type="primary">关闭弹窗</el-button>
          <el-button v-else size="mini" @click="sysMsgDialogShow = false" type="primary">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
import {mapGetters, mapMutations, mapState} from "vuex";
import errorHandleMixin from "@mixins/errorHandleMixin";
import {MyMixin} from "@mixins/aliyunCallMixin"

import Push from 'push.js'
import checkEarPhone from './checkEarPhone'
import dayjs from "dayjs";
import {
  RestPCMessageCallcenterControllerGetNewestMessage,
  RestAuthLogout,
  RestFeedbackOutControllerGetFeedbackList,
  RestFeedbackOutControllerGetIsAllRead,
  RestFeedbackOutControllerConfirmFeedbackById,
  RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByUserId,//学习材料--任务
  RestNewFollowupCallCenterServiceGetStudyListByTask, //学习材料--材料
  RestNewFollowupCallCenterServiceGetStudyById,
  RestFeedbackOutControllerGetPassFailFeedBackList,
  RestNewFollowupCallCenterServiceGetCallReminderLater
} from "@src/assets/js/api.js";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import HrQualityControl from "./components/hr-quality-control";
import FeedbackDrawer from "./components/hr-quality-control/feedbackDrawer.vue";
import previewFileDialog from '@/components/previewFileDialog'

import quotaTable from "../pages/components/quotaTable";
export default {
  name: "Header",
  data() {
    return {
      previewDialogVisible: false,
      previewStuff: "",
      previewSrc: "",
      selectFloder: "",
      fileList: [],
      floderList: [],
      path: "",
      showTaskTitle: false,
      showUserMenu: false,
      debugType: 'earphone',
      defaultDevices: {
        mic: null,
        earphone: null
      },
      checkAudioVisible: false,
      speed: null,
      dialogVisible: false,
      feedbackTooltipShow: true, //质控反馈透明框
      dialogDebugVisible: false,
      callReminderShow: true, //稍后拨打提醒
      message: null,
      rebackPhone: "02160664693",
      title: "荟医电话随访呼叫系统",
      status: "work", // 可以打电话
      isCalling: false, // 拨打状态
      isCallHold: true, //通话保持
      seconding: 0,
      intervalTimer: null,
      callingNumber: "",
      socket: null,
      callingNumberList: [
        "0755765578011265",
        "0755765578011267",
        "0755765578011268",
        "0755765578011264",
        "0755765578011263",
        "0755765578011272",
        "0755765578011271",
        "0755765578011270",
        "0755765578011266",
        "0755765578011269",
        "028800600072",
        "057100000724"
      ],
      dialogTableVisible: false,
      isAllRead: null, // 1已经全读 0 未
      unreadCount: 0,  //未读数量
      activeNames: null,
      feedBackList: [],
      pageIndex: 1,
      totalFeedBackPage: 10,
      feedBackNotConfirm: [],  //未读的反馈
      studyDrawer: false, //学习材料侧边框
      taskOptions: [],
      studyOptions: [],
      taskId: '',
      studyId: '',
      studyContent: "",
      showViewer: false, // 学习材料-预览图片
      imagePreviewUrl: "",
      dialogActiveName: "feedback",
      timer: null,
      passFailed: `质控未通过提醒`,
      callReminderInfo: [], //稍后拨打提醒
      feedbackDrawer: false,
      sysMsgDialogShow:false,
      noticeData:{}, //公告内容
    };
  },
  computed: {
    ...mapGetters(["isLogin", "username", "userid", "getCallingNumber", "getTaskCenterId"]),
    ...mapState(["taskTitle", "callObj", "nextCallNumber", "nextCallNumberId"]),

    // 工号
    jobnum() {
      return (this.isLogin && this.userid) || "";
    },
    jobName() {
      return (this.isLogin && this.username) || "";
    },
    showTitle() {
      let path = this.$route.path;
      return path == '/callPatient' || path == '/internalQualityControl'
    },
    //显示是否显示 打电话
    showCallBtn() {
      let path = this.$route.path;
      return path === "/patient" || path === "/callPatient";
    },
    showHomeIcon() {
      let path = this.$route.path;
      return path === "/patient" || path === "/callPatient";
    },
    showRefreshIcon() {
      // 任务列表页面
      let path = this.$route.path;
      let result =
          path === "/taskList" || path === "/tasks" || path === "/taskDetail";
      return result;
    },
    showBackIcon() {
      // 任务分配页面
      let path = this.$route.path;
      return path === "/tasks";
    },
    // 显示 00:00
    secondText() {
      let value = this.seconding;
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime >= 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle >= 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result =
          parseInt(theTime) < 10
              ? "0" + parseInt(theTime)
              : "" + parseInt(theTime);
      var middleText =
          parseInt(middle) < 10 ? "0" + parseInt(middle) : "" + parseInt(middle);
      result = middleText + ":" + result;
      if (hour > 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    noviceProtectionEndTime() {
      let path = this.$route.path;
      let result = path === "/callPatient"?localStorage.getItem('noviceProtectionEndTime') : ""
      console.log('');
      return result
    }
  },
  watch: {},
  mixins: [errorHandleMixin, MyMixin],
  components: {
    checkEarPhone,
    ElImageViewer,
    HrQualityControl,
    previewFileDialog,
    FeedbackDrawer,
    quotaTable
  },
  created() {
    Push.Permission.request();
    this.onLoad();
  },
  methods: {
    ...mapMutations([
      "setTaskCenterId",
      "setTaskTitle",
      "logout",
      "callEvent",
      "setCurrentCallNumber",
      "setCurrentCalling",
      "setCallingNumber",
      "setQuestion"
    ]),
    previewHandler(params) {
      let office = ['.pptx', '.ppt', '.doc', '.docx', '.xls', '.xlsx',]
      let video = ['.mp4', '.avi', '.mpg', '.mpeg', '.mov', '.wmv']
      let audio = ['.mp3','.wav','.wma','.flac','.midi','.mov']
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetPreviewFileUrl',
        params: {
          fileId: params.id
        }
      }).then((res) => {
        this.previewStuff = params.fileSuffix
        if (office.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(res.retValue)}&wdOrigin=BROWSELINK`
          this.previewStuff = 'office'
        } else if (params.fileSuffix == '.pdf') {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pdf'
        } else if (video.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'video'
        } else if (audio.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'audio'
        } else {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pic'
        }
        this.previewDialogVisible = true
      })
    },
    selectFloderHandler(val) {
      this.getFileList({
        folderId: val,
        flag: 2,
      }).then(res => {
        this.fileList = res.retValue
      })
    },
    getFolderList(p) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFolderNameList',
        params: {
          followUpTaskId: this.taskId,
          flag: p.flag
        }
      }).then(res => {
        this.floderList = res.retValue
      })
    },
    async getFileList(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFileListByTaskId',
        params: {
          folderId: p.folderId,
          flag: p.flag,
          taskId: this.taskId
        }
      })
      return result
    },
    pushMessage(message) {
      Push.create("消息通知的标题", {
        body: message,
        requireInteraction: true,
        timeout: 600000,
        onClick: function () {
          alert('clicked')
        }
      });

    },

    changeType(type) {
      this.debugType = type
    },
    getDevices() {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        let defaultDevices = devices.filter(item => item.deviceId == 'default')
        if (!defaultDevices.length) {
          this.defaultDevices = {
            earphone: "",
            mic: ""
          }
          return
        }
        this.defaultDevices.earphone = defaultDevices.filter(item => item.kind == 'audiooutput')[0].label.replace('默认值 -', "")
        this.defaultDevices.mic = defaultDevices.filter(item => item.kind == 'audioinput')[0].label.replace('默认值 -', "")
      })
    },
    earphoneCloseHandler() {
      this.dialogDebugVisible = false
    },
    getSpeed() {
      // this.checkAudioVisible = true
      this.measureBW((speed) => {
        this.speed = speed
      }, 3)
    },
    measureBW(fn, time) {
      time = time || 1;
      var startTime, endTime, fileSize;
      var count = time;
      var _this = this;

      function measureBWSimple() {

        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (!fileSize) {
              fileSize = xhr.responseText.length;
            }
            count--;
            if (count <= 0) {
              endTime = Date.now();
              var speed = fileSize * time / ((endTime - startTime) / 1000) / 1024;
              fn && fn(Math.floor(speed));
            }
          }
        }
        xhr.open("GET", "https://huiyi-dev-patient-upload.oss-cn-hangzhou.aliyuncs.com/questionAnswerUrl/1597806894761%E5%90%B8%E9%BC%BB%E5%99%A8banner(7)(1).png", true);
        xhr.send();
      }

      startTime = Date.now();
      for (var x = time; x > 0; x--) {
        measureBWSimple()
      }
    },
    webSocket() {
      const that = this;
      if (typeof WebSocket == "undefined") {
      } else {
        const socketUrl = "wss://callcentertest.huidr.com/websocket/callCenter";
        this.socket = new WebSocket(socketUrl);
        this.socket.onopen = function () {
          that.socket.send(`what's your name`);
        };
        this.socket.onmessage = function (msg) {
          // const data = JSON.parse(msg.data)
          that.$notify({
            title: "建立连接",
            // 这里也可以把返回信息加入到message中显示
            message: "实时报警服务连接成功，点击查看报警信息详情",
            type: "success",
            duration: 1000,
            onClick: () => {
              that.$router.push({
                path: "/alarmManage/monitAlarmInfo"
              });
            }
          });
        };

        this.socket.onerror = function () {
          that.$notify({
            title: "错误",
            message: "服务器错误，无法接收实时报警信息",
            type: "error",
            duration: 0
          });
        };

        this.socket.onclose = function () {
        };
      }
    },
    getMessage() {
      this.dialogVisible = true;
    },
    getDebugDialog(type) {
      this.debugType = type
      this.dialogDebugVisible = true;
    },
    closeFeedbackTooltip() {
      this.feedbackTooltipShow = false;
    },
    closeCallReminderTooltip(param, index) {
      // this.callReminderShow = false;
      // 稍后：通过删除数组中对应的数据达到“删除”效果
      this.callReminderInfo.splice(index, 1);
    },
    onLoad() {
      // this.getIsAllRead();
      this.feedbackTooltipShow = false;
      this.callReminderShow = false;
      // this.getFeedBackList();
      this.getSpeed()
      this.getDevices()

    },
    openFeedbackDrawer(){
      this.timer = new Date().getTime()
      this.feedbackDrawer = true
    },
    // 退登
    loginOut() {
      let vm = this;
      this.$confirm("确定要退出登录吗?", "通知", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.logOutAsync().then(res => {
              if (res.status == 0) {
                // 空闲，小休 ，话后处理 , 签出 , 注册中
                let code = this.getCurrentCode();
                if (window.workbench) {
                  let codeArr = [3, 4, 5, -1, 1, 0];
                  if (codeArr.indexOf(code) > -1) {
                    // window.workbench && window.workbench.logoutAliyunAccount(); // 退出阿里云账号
                    setTimeout(() => {
                      window.workbench && window.workbench.logOut(); // 下线
                      window.workbench = null;
                      window.pubsub.emit("logout");
                      vm.$router.push({path: "/login?logout=true"});
                    }, 1000);
                  } else {
                    vm.$message({
                      type: "warning",
                      message: "请结束手上的工作，才能结束"
                    });
                  }
                } else {
                  vm.$router.replace({path: "/login"});
                }
              }
            });
          })
          .catch(() => {
          });
    },
    async logOutAsync() {
      let request = new RestAuthLogout();
      request.p_id = sessionStorage.getItem('userid')
      await request.send();
      return request.result;
    },
    // 质控反馈
    getFeedBackList() {
      this.getFeedbackListAsync({
        pageIndex: this.pageIndex,
        pageSize: 10,
        seatId: sessionStorage.getItem("userid")
      }).then(res => {
        this.feedBackList = res.retValue;
        this.totalFeedBackPage = res.totalPage;
        // 显示最新未读质控反馈
        let feedback_arr = res.retValue.filter(item => {
          return item.isConfirm == false
        })
        if (feedback_arr.length > 0 && this.feedBackNotConfirm.id !== feedback_arr[0].id) {
          this.feedbackTooltipShow = true;
          this.feedBackNotConfirm = feedback_arr[0];
        }
      });
    },
    // 稍后拨打：定时，功能类似于质控反馈弹框
    getCallReminderLater() {
      console.log('稍后拨打，，缺少内容');
      this.getCallReminderLaterAsync().then(res => {
        if (res.retValue.length > 0) {
          this.callReminderShow = true;
          this.callReminderInfo = res.retValue
        }
      });
    },
    openDialog() {
      this.dialogTableVisible = true;
      this.dialogActiveName = "feedback";
      this.getFeedBackList();
      this.getPassFailFeedBackList()
    },
    goTaskDetail() {
      this.dialogTableVisible = true;

      // 关闭
      this.feedbackTooltipShow = false;
    },
    confirmStatusHandler() {
      this.confirmStatus({
        userId: this.userid,
        messageId: this.noticeData.id,
        classification: this.noticeData.classification
      }).then(res => {
        if (res.status == 0) {
          this.$message.success(res.retValue)
          this.sysMsgDialogShow = false
          this.$refs.FeedbackDrawer.getSystemMessage()
        }else {
          this.$message.error(res.retValue)
        }
      })
    },
    async confirmStatus(p) {
      let result = await this.$store.dispatch('requestHandler',{
        fn: 'RestCallCenterOperationPlatformControllerUpdateMsgConfirmStatus',
        params: {
          userId: p.userId,
          messageId: p.messageId,
          classification: p.classification,
        }
      })
      return result
    },
    // 稍后拨打提醒--查看
    goCallLaterTaskDetail(params) {
      if (localStorage.getItem('callStatus') == 'true') {
        this.$message({
          type: "error",
          message: "操作失败！当前正在通话中"
        });
      } else {
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: params.taskId,
            }
          }
        ).then(res => {
          this.setQuestion(res.retValue)
          this.setTaskCenterId(params.taskId);
          this.setTaskTitle(params.taskName);
          localStorage.setItem('taskId', params.taskId)
        if (window.workbench) {
          this.$router.push({
            path: "/callPatient",
            query: {
              abnormal: 4,
              followUpPatientInfoId: params.followupPatientInfoId,
              followupPatientId: params.followupPatientId,
              diseaseId: params.diseaseId,
              patientId: params.patientId,
              followupSource: 1,
              isRemindStudy: false,
              isSingleDuration: false,
              isTotalDuration: false
            }
          });
        } else {
          const loading = this.$loading({
            lock: true,
            text: '正在登录阿里云请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.initAliyunCall()
                .then(result => {
                  console.log('result', result);
                  if (result) {
                    this.$router.push({
                      path: "/callPatient",
                      query: {
                        abnormal: 4,
                        followUpPatientInfoId: params.followupPatientInfoId,
                        followupPatientId: params.followupPatientId,
                        diseaseId: params.diseaseId,
                        patientId: params.patientId,
                        followupSource: 1,
                        isRemindStudy: false,
                        isSingleDuration: false,
                        isTotalDuration: false
                      }
                    });
                    this.clearInter();
                    loading.close();
                  }
                })
          }
        })
      }
    },
    handleChange(val) {
      console.log(val);
      this.confirmFeedbackById({
        id: this.feedBackList[val].id,
        spotCheckId: this.feedBackList[val].spotCheckId
      }).then(res => {
        this.feedBackList[val].isConfirm = true;
        // this.getIsAllRead();
      });
    },
    current_change_feedBackList(currentPage) {
      this.pageIndex = currentPage;
      this.getFeedBackList();
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    async getFeedbackListAsync(p) {
      let request = new RestFeedbackOutControllerGetFeedbackList();
      request.p_pageIndex = p.pageIndex;
      request.p_pageSize = p.pageSize;
      request.p_seatId = p.seatId;
      await request.send();
      return request.result;
    },
    async confirmFeedbackById(p) {
      let request = new RestFeedbackOutControllerConfirmFeedbackById();
      request.p_id = p.id;
      request.p_userId = sessionStorage.getItem("userid")
      request.p_spotCheckId = p.spotCheckId
      await request.send();
      return request.result;
    },
    // async getIsAllReadAsync(p) {
    //   let request = new RestFeedbackOutControllerGetIsAllRead();
    //   request.p_seatId = p.seatId;
    //   await request.send();
    //   return request.result;
    // },
    async getPassFailFeedBackListAsync() {
      let request = new RestFeedbackOutControllerGetPassFailFeedBackList()
      request.p_userId = sessionStorage.getItem("userid")
      await request.send()
      return request.result
    },
    getPassFailFeedBackList() {
      this.getPassFailFeedBackListAsync().then(res => {
        let filterData = res.retValue.filter(item => {
          return item.isConfirm == false
        })
        this.passFailed = filterData.length > 0 ? `质控未通过提醒（${filterData.length}）` : `质控未通过提醒`

      })
    },
    // ----------------------------- 打电话系列 ------------------------------------
    // 小休
    getRest() {
      if (window.workbench) {
        if (this.getCurrentCode() == 3) {
          this.status = "rest";
          window.workbench && window.workbench.applyForBreak(1, "临时有事");
        } else {
          this.$message({
            type: "warning",
            message: "您好，此时您的状态不能进行小休"
          });
        }
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 回到岗位
    backWork() {
      if (window.workbench) {
        this.status = "work";
        // 上线
        window.workbench && window.workbench.ready();
        window.workbench &&
        this.callEvent({
          callCode: "3",
          callCodeValue: "空闲"
        });
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // ------------------------------------------打电话---------------------------------------------
    /**
     * 手动选择主叫号码
     */
    manualSelectCalling(callingNumber) {
      let vm = this;
      console.log("callingNumber===>", callingNumber);
      vm.setCallingNumber(callingNumber);
    },
    // 拨打电话
    calling() {
      if (window.workbench) {
        if (this.status === "work") {
          // call(callee, caller, publicKey, useVirNumCall)
          // callee为被叫号码不可空，必传，加密时传加密后的密文，不加密时传真实被叫号码。
          // caller为主叫号码，可以指定主叫号码，不使用加密时可以不传，或者传‘auto’。不传时使用面板里选择的主叫号码或技能组所绑定外呼号码的第一个,为‘auto’时，根据外呼的号码的归属地选择与与其同一归属地的主叫号码，若没有同一归属地的就随机在技能组里选择一个主叫号码。使用加密时必传。
          // publicKey为公钥，对被叫号码进行加密时该值必传，非加密情况不传或传空值。使用加密方式外呼时,需要调用加密接口 [Encrypt ](https://help.aliyun.com/document_detail/75726.html) 将号码进行加密，得到加密后的被叫号码和公钥后直接调用该call方法：call('密文', '主叫号码', '公钥' )。
          // useVirNumCall为Boolean类型，传true表示只要caller配置了虚拟号码都会使用虚拟号码进行外呼，不传或传false,如果您使用呼叫中心的面板进行操作，会根据坐席是否选择使用外呼号码进行呼叫，如果勾选了则将使用虚拟号码进行外呼否则直接用呼叫中心的号码进行呼叫。
          console.log("calling  -------------- ", this.nextCallNumber);
          if (this.nextCallNumber) {
            window.workbench.call(
                this.nextCallNumber,
                this.getCallingNumber,
                null,
                false
            ); // TODO
            setTimeout(() => {
              this.setCurrentCallNumber({
                currentCallNumber: this.nextCallNumber,
                currentCallNumberId: this.nextCallNumberId
              });
              this.setCurrentCalling(true);
              this.setCallingStatus();
              window.pubsub && window.pubsub.emit("calling");
            }, 1000);
          } else {
            this.errorHandle({
              message: "该患者无可拨打的电话"
            });
          }
          // // for 测试
          // window.workbench.call("15708497684", "auto", null, false); // TODO
          // this.setCurrentCallNumber({currentCallNumber:this.nextCallNumber ,currentCallNumberId : this.nextCallNumberId})
          // this.setCallingStatus();
          // window.pubsub&&window.pubsub.emit('calling');
        } else {
          this.errorHandle({
            message: "请先重新回到工作中。。。"
          });
        }
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 可以  -----  挂断
    hangUp() {
      if (window.workbench) {
        // 挂断
        window.workbench.hangUp();
        this.setCurrentCalling(false);
        this.setHangUpStatus();
        window.pubsub && window.pubsub.emit("callHangUp");
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 电话保持
    callHold() {
      if (window.workbench) {
        if (this.getCurrentCode() == 10 || this.getCurrentCode() == 9) {
          window.workbench.callHold();
          this.isCallHold = false;
        } else {
          this.$message({
            type: "warning",
            message: "您好，此时您的状态不能进行通话保持"
          });
        }
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 电话取回
    callRetrieve() {
      // 12
      if (window.workbench) {
        // 挂断
        window.workbench.callRetrieve();
        this.isCallHold = true;
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 挂断后的状态
    setHangUpStatus() {
      this.intervalTimer && clearInterval(this.intervalTimer);
      this.seconding = 0;
      this.isCalling = false;
    },
    // 拨打的状态
    setCallingStatus() {
      this.isCalling = true;
      this.intervalTimer = setInterval(() => {
        this.seconding++;
      }, 1000);
    },
    // 给你个刷新页面的数据接口
    refresh() {
      window.pubsub && window.pubsub.emit("refreshHomePage");
    },
    back() {
      // 回到上一页
      window.pubsub && window.pubsub.emit("backPreviousPage");
    },
    // home
    home() {
      this.$router.push({
        path: "/taskDetail",
        query: {
          diseaseId: this.$route.query.diseaseId
        }
      });
    },
    // 获取当前的拨叫状态
    getCurrentCode() {
      return (
          (window.workbench &&
              window.workbench.getStatusCode() &&
              window.workbench.getStatusCode().code) ||
          null
      );
    },

    getMessageList() {
      this.getNewMessageListAsync().then(res => {
        this.message = res.retValue;
      });
    },

    async getNewMessageListAsync() {
      let request = new RestPCMessageCallcenterControllerGetNewestMessage();
      await request.send();
      return request.result;
    },
    // getIsAllRead() {
    //   this.getIsAllReadAsync({
    //     seatId: sessionStorage.getItem("userid")
    //   }).then(res => {
    //     this.unreadCount = res.retValue.unreadCount;
    //   });
    // },

    // 定时装置设置
    setFeedBackTime() {
      let _this = this
      _this.interval_feedback = setInterval(function () {
        _this.getFeedBackList();
        // _this.getIsAllRead();
        _this.getCallReminderLater();
      }, 1000 * 60 * 5);
    },
    closeDialog() {
      this.dialogTableVisible = false
    },
    closeDrawer(){
      this.feedbackDrawer = false
    },
    openNotice(data){
      this.noticeData.quotaDetail = null
      this.noticeData = data
      this.noticeData.classificationTitle = this.noticeData.classification==2?"指标核对": (this.noticeData.classification==3?"工作计划":"")
      if(data.classification != 1) {
        this.getQuotaTableInfoAsync({
          seatId: this.userid,
          messageId: data.id,
          classification: data.classification
        }).then(res => {
          this.noticeData.quotaDetail = res.retValue
          if(res.retValue && res.retValue.tableInfo.length>0) {
            this.$forceUpdate()
            this.sysMsgDialogShow = true
          }else {
            this.$message.info("暂无工作安排/结果需要确认，请与部门主管联系")
          }
        })
      }else {
        this.sysMsgDialogShow = true
      }
    },
    //--------------------  学习材料  --------------------
    studyDrawerClick() {
      this.studyDrawer = true;
      this.showUserMenu = false;
      this.studyContent = "";
      // this.taskId = "";
      // this.studyId = "";
      console.log("任务id--->", this.getTaskCenterId);
      this.getQueryQFollowUpTaskListById().then(res => {
        this.taskOptions = res.retValue;
        if (this.$route.path == "/callPatient" || this.$route.path == "/taskDetail") {
          this.taskId = this.getTaskCenterId;
          this.selectTaskHandler();
        }
        this.studyContent = "";
      });
    },
    selectTaskHandler() {
      this.studyId = "";
      this.studyContent = "";
      this.selectFloder = ""
      this.getFolderList({
        flag: 1
      })
      this.getFileList({
        folderId: null,
        flag: 2,
      }).then(res => {
        this.fileList = res.retValue
      })

    },
    searchQAList() {
      this.getStudyDetailById().then(res => {
        this.studyContent = res.retValue.content;
      })
    },
    handleDrawerClose(done) {
      this.studyDrawer = false;
    },
    // 图片问题
    showImg(e) {
      if (e.target.tagName == "IMG") {
        this.showViewer = true;
        this.imagePreviewUrl = e.target.src;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    async getQueryQFollowUpTaskListById() {
      let request = new RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByUserId();
      request.p_userId = this.userid;
      await request.send();
      return request.result;
    },
    async getStudyListByTask() {
      let request = new RestNewFollowupCallCenterServiceGetStudyListByTask();
      request.p_taskId = this.taskId
      request.p_isAdd = true
      await request.send();
      return request.result;
    },
    async getStudyDetailById() {
      let request = new RestNewFollowupCallCenterServiceGetStudyById();
      request.p_studyId = this.studyId
      await request.send();
      return request.result;
    },
    // 稍后拨打
    async getCallReminderLaterAsync() {
      let request = new RestNewFollowupCallCenterServiceGetCallReminderLater()
      request.p_userId = this.userid
      await request.send()
      return request.result
    },
    //获取指标预告 核算
    async getQuotaTableInfoAsync(params) {
      let result = await this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetQuotaTableInfo',
            params: {
              seatId: params.seatId,
              messageId: params.messageId,
              classification: params.classification,
            }
          }
      )
      return result
    },
    // ---------------------------------------------------------
    handleClick(tab, event) {
      if (tab.name == "remind") {
        this.timer = new Date().getTime()
        this.passFailed = this.$refs.HrQualityControl.passFailedCount > 0 ? `质控未通过提醒（${this.$refs.HrQualityControl.passFailedCount}）` : `质控未通过提醒`
      }
    },
  },
  mounted() {

    // this.pushMessage('消息通知的内容');
    this.getMessageList();
    // setInterval(() => {
    //     this.message = {};
    //     this.getMessageList();
    // }, 300000);
    // this.webSocket()
    // 长时间闲置 会 将状态 设置为 小休状态
    window.pubsub &&
    window.pubsub.off("goRest").on("goRest", () => {
      this.status = "rest";
    });
    let code = this.getCurrentCode();
    if (code === 3) {
      this.status = "work";
    } else if (code === 4) {
      // 小休
      this.status = "rest";
    }
    this.getFeedBackList();
    this.getCallReminderLater();
    this.setFeedBackTime();
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    clearInterval(this.interval_feedback);
  },

};
</script>
<style lang="scss">
.ove {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.header {
  .el-dialog {
    border-radius: 8px !important;
  }

  .el-dialog__body {
    text-align: left;
    padding: 10px 32px 32px 32px;

    .height-light .el-collapse-item__header {
      background: #fff7005f;
    }
  }
}

.feedback-dialog {
  .el-dialog__body {
    .el-tabs__content {
      overflow: auto;
      position: relative;
      min-height: 560px;
    }

    .el-tabs__nav-wrap::after {
      position: static !important;
    }
  }
}
.ql-size-huge {
  font-size: 2.5em;
}
.ql-size-large {
  font-size: 1.5em;
}
.ql-size-small {
  font-size: 0.75em;
}
.sysMsgDialog {
  .weekstar_img {
    object-fit: fill;
    width: 60%;
  }
  strong {
    font-weight: bold !important;
  }
  p {
    word-break: break-all;
    word-wrap: break-word;
    line-height: 1;
  }
  ul {
    padding: 0 1em;
    list-style-type: disc !important;
    list-style-position: inside !important;
  }
  ol {
    padding: 0 1em;
    list-style-type: decimal !important;
    list-style-position: inside !important;
  }
  li {
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
}
</style>
<style scoped lang="scss">
.study-list {
  padding-left: 10px;
  padding-right: 10px;
  min-height: 600px;
  height: 770px;
  overflow: scroll;

  .article-item {
    display: flex;
    justify-content: space-between;
    height: 40px;
    cursor: pointer;
    align-items: center;
  }
}

.setting {
  font-size: 14px;
  color: #000;
  width: 100%;

  &-item {
    text-align: left;
    height: 45px;
    line-height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      display: block;
      padding: 0 10px;
      margin: 0 10px;
    }

    .network {
      padding-right: 20px;
      display: flex;
      align-items: center;
    }
  }

  .user-info {
    border: 0;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hover:hover {
    background: #c4e1ff;
    cursor: pointer;
  }

  .logout {
    text-align: right;
    border: 0;
    height: 60px;
    line-height: 60px;

    span {
      padding: 8px 10px;
      border: 0;
      display: inline;
    }

    img {
      width: 18px;
      margin: 0 5px;
      margin-bottom: -4px;
    }

    span:hover {
      cursor: pointer;
      background-color: #ccc;
      border-radius: 6px;
    }
  }
}

header {
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  background: #248cfa;
  color: #ffffff;
  z-index: 400;


  .left {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding-left: 30px;
    flex: 1;

    .refresh,
    .home,
    .back {
      font-size: 40px;
      box-sizing: border-box;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      padding-right: 10px;

      & > .el-icon-refresh {
        font-size: 40px;
        padding-right: 5px;
      }

      & > .el-icon-s-home {
        font-size: 40px;
        padding-right: 5px;
      }

      & > .el-icon-back {
        font-size: 40px;
        padding-right: 5px;
      }
    }

    .logo {
      width: 60px;
      height: 60px;
      background: url("./img/logo.png") no-repeat;
      background-position: top 2px center;
      background-size: 60px 60px;
      margin-right: 20px;
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      margin-right: 30px;
    }

    .phone-number {
      background: rgba(#283c57, 0.2);
      font-size: 22px;
      box-sizing: border-box;
      border: 1px solid rgba(#1d3050, 0.1);
      box-shadow: 0 1 1 0 rgba(255, 255, 255, 0.3);
      border-radius: 28px;
      height: 60px;
      line-height: 24px;
      padding: 12px 24px;
    }
  }

  .taskTitle {
    font-weight: 700;
    font-size: 20px;
    display: inline-block;
    height: 60px;
    line-height: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .center {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    width: 31%;
    padding-left: 40px;
  }

  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;
    position: relative;
    width: 30%;

    .item {
      display: inline-block;

      & > input {
        border: none;
        outline: none;
      }
    }

    & > .item.gonghao {
      font-size: 20px;
      margin-right: 20px;
      height: 60px;
      line-height: 60px;
    }

    & > .item.feedback {
      .feedback-btn {
        margin: 0 10px;
        border: 1px solid rgba(29, 48, 80, 0.1);
        background: rgba(40, 60, 87, 0.2);
      }

      .feedback-btn > span {
        display: flex;
        align-items: center;
      }

      .feedback-btn-bot {
        background: red;
        color: #fff;
        width: 18px;
        height: 18px;
        line-height: 18px;
        border-radius: 50%;
        margin-right: 5px;
        display: inline-block;
      }

    }

    & > .item.avatar {
      /*border: 1px solid rgba(29, 48, 80, 0.1);*/
      /*background: rgba(40, 60, 87, 0.2);*/
      position: relative;


    }

    .user-icon {
      width: 40px;
      display: flex;
      align-items: center;

      img {
        width: 100%;
        cursor: pointer;
      }
    }

    // 质控提示透明框
    .feedback-tooltip {
      display: grid;
      grid-template-columns: 80% 20%;
      grid-template-rows: 100%;
      color: #000;
      width: 450px;
      min-height: 94px;
      font-size: 14px;
      position: absolute;
      top: 5px;
      right: 260px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.22) 19.27%, rgba(255, 255, 255, 0.22) 27.08%, rgba(255, 255, 255, 0.5) 68.23%, rgba(255, 255, 255, 0.22) 100%);
      border: 1px solid rgba(168, 187, 217, 0.5);
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25), inset 0px 2px 5px rgba(255, 255, 255, 0.25);
      backdrop-filter: blur(12px);
      border-radius: 10px;

      &-left {
        border-right: 1px solid #ccc;
        padding: 10px;

        .tooltip-title {
          display: flex;
          justify-content: space-between;

          span {
            color: #303133;
            font-size: 10px;
          }

          span:first-child {
            font-weight: bold;
            color: #000;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .tooltip-content {
          // padding-top: 10px;
          line-height: 20px;

          &-question {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &-result {
            display: grid;
            grid-template-columns: 50% 50%;

            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      &-right {
        div {
          height: 52px;
          text-align: center;
          line-height: 52px;
        }

        .div1 {
          border-bottom: 1px solid #ccc;
          border-radius: 0 10px 0 0;
        }

        .div2 {
          border-radius: 0 0 10px 0;
        }

        div:hover {
          cursor: pointer;
          background-color: rgba(0, 0, 0, .3);
        }
      }
    }

    /*border: 1px solid rgba(29, 48, 80, 0.1);*/
    /*background: rgba(40, 60, 87, 0.2);*/
    /*position: relative;*/


  }

  .callingtime {
    font-size: 20px;
    padding-right: 10px;
  }

  & > .item.btn {
    font-size: 20px;
    margin-right: 20px;
    border: 1px solid rgba(#1d3050, 0.1);
    box-shadow: 0 1 1 0 rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    background: rgba(#283c57, 0.2);
    padding: 0 20px;
  }

  & > .item:nth-last-of-type(1) {
    background: rgba(#283c57, 0.2);
    font-size: 20px;
    width: 50px;
    box-sizing: border-box;
    border: 1px solid rgba(#1d3050, 0.1);
    box-shadow: 0 1 1 0 rgba(255, 255, 255, 0.3);
    border-radius: 25px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    text-align: center;

    & > .el-icon-close {
      font-size: 16px;
      padding-right: 5px;
    }
  }


  .image-item {
    display: inline-block;
    cursor: pointer;
    width: 80px;
    height: 80px;
    padding: 10px;
  }
}
.sysMsgDialog {
  .content {
    height: 60vh;
    overflow: auto;
    font-size: 16px;
    .title {
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
    }

    .content_main {
      line-height: 22px;
    }
  }

}
.study-drawer {
  position: absolute;
  top: 0;
  right: 5px;
  box-shadow: -3px 3px 3px #eee;
  border: 1px solid #eee;
  background: #fff;
  width: 30%;
  height: calc(98vh);
  margin: 10px 0;
  color: #000;
  z-index: 999;
  border-radius: 4px;

  .drawer-title {
    display: grid;
    grid-template-columns: 90% 10%;
    margin: 20px 10px;

    span {
      width: 100%;
      text-align: center;
    }

    i {
      cursor: pointer;
      text-align: center;
    }
  }

  .drawer-container {
    padding: 10px 30px;
    height: 93%;
    display: flex;
    flex-direction: column;

    .study-searcher {
      .el-select {
        width: 100%;
        margin-bottom: 10px;
      }
    }

    .study-content {
      height: 100%;
      overflow: auto;
    }
  }
}
</style>